/**
 * Librería de códigos de Tipos de envíos
 */
export enum ShippingTypesCodes {
  NATIONAL_SHIPMENT = 1,
  PICK_UP = 2,
}
